export default "__VITE_ASSET__39f17f3a__"